import { Box } from '@amzn/ring-ui-react-components';
import { BaseOptionType } from './types';
import type { MultiValueGenericProps } from 'react-select';

export interface MultiValueLabelProps<OptionType extends BaseOptionType>
  extends MultiValueGenericProps<OptionType> {}

export const MultiValueLabel = <OptionType extends BaseOptionType>({
  data,
  innerProps,
}: MultiValueLabelProps<OptionType>) => (
  <Box {...innerProps} as="label" ml={2} textStyle="body-normal-medium">
    {data.label}
  </Box>
);
